export const STONE_BANNER = {
  developerId: 7229,
};
